(() => {
  "use strict";

  if (window.eyeCandyCollectionCartLoaded) return;
  window.eyeCandyCollectionCartLoaded = true;

  const config = document.querySelector("[data-ec-cart]");
  if (!config) return;

  const addLabel = config.dataset.addLabel || "Add to cart";
  const optionsLabel = config.dataset.optionsLabel || "Choose options";
  const addedLabel = config.dataset.addedLabel || "Added to cart";
  const soldOutLabel = config.dataset.soldOutLabel || "Sold out";
  const productRequests = new Map();

  function productHandleFromCard(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return "";
    const match = link.getAttribute("href")?.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function getActionContainer(card) {
    let actions = card.querySelector(".ec-card-actions");
    if (actions) return actions;

    actions = document.createElement("div");
    actions.className = "ec-card-actions";
    const cardInfo = card.querySelector(".card-info") || card;
    const price = cardInfo.querySelector(".x-card-price");
    if (price) price.insertAdjacentElement("afterend", actions);
    else cardInfo.append(actions);
    return actions;
  }

  function loadProduct(handle) {
    if (!productRequests.has(handle)) {
      const routeRoot = window.Shopify?.routes?.root || "/";
      productRequests.set(handle, fetch(`${routeRoot}products/${encodeURIComponent(handle)}.js`, {
        headers: { Accept: "application/json" }
      }).then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      }).catch((error) => {
        productRequests.delete(handle);
        throw error;
      }));
    }
    return productRequests.get(handle);
  }

  function findThemeOptionsButton(card) {
    const candidates = [...card.querySelectorAll('button[aria-label="Choose options"]')];
    return candidates.find((button) => button.offsetParent !== null) || candidates[0] || null;
  }

  function openThemeOptions(card) {
    const themeButton = findThemeOptionsButton(card);
    if (!themeButton) return false;
    themeButton.dispatchEvent(new MouseEvent("mouseover", { bubbles: true }));
    window.setTimeout(() => themeButton.click(), 80);
    return true;
  }

  function refreshEurusCart(payload) {
    document.dispatchEvent(new CustomEvent("eurus:cart:reload", { detail: payload }));
    document.dispatchEvent(new CustomEvent("eurus:cart:items-changed", { detail: payload }));
    document.dispatchEvent(new CustomEvent("eurus:product:added", { detail: payload }));
    try {
      window.Alpine?.store("xMiniCart")?.openCart?.();
    } catch {
      // The cart is still updated when the optional drawer API is unavailable.
    }
  }

  async function addVariant(variantId) {
    const routeRoot = window.Shopify?.routes?.root || "/";
    const response = await fetch(`${routeRoot}cart/add.js`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });
    const payload = await response.json();
    if (!response.ok) throw new Error(payload.description || "Unable to add this item.");
    refreshEurusCart(payload);
    return payload;
  }

  async function handleCartClick(button, card, handle) {
    if (button.dataset.mode === "options") {
      if (!openThemeOptions(card)) window.location.assign(`/products/${handle}`);
      return;
    }

    button.disabled = true;
    button.textContent = "Loading...";

    try {
      const product = await loadProduct(handle);
      const variants = Array.isArray(product.variants) ? product.variants : [];

      if (variants.length > 1) {
        button.dataset.mode = "options";
        button.textContent = optionsLabel;
        button.disabled = false;
        if (!openThemeOptions(card)) window.location.assign(product.url || `/products/${handle}`);
        return;
      }

      const variant = variants[0];
      if (!variant?.available) {
        button.textContent = soldOutLabel;
        button.classList.add("is-sold-out");
        return;
      }

      await addVariant(variant.id);
      button.textContent = addedLabel;
      button.classList.add("is-added");
      window.setTimeout(() => {
        button.textContent = addLabel;
        button.classList.remove("is-added");
        button.disabled = false;
      }, 2200);
    } catch {
      button.disabled = false;
      button.textContent = addLabel;
      if (!openThemeOptions(card)) window.location.assign(`/products/${handle}`);
    }
  }

  function injectButtons() {
    document.querySelectorAll(".card-product").forEach((card) => {
      if (card.querySelector(".ec-card-cart-button")) return;
      const handle = productHandleFromCard(card);
      if (!handle) return;

      const button = document.createElement("button");
      button.className = "ec-card-cart-button";
      button.type = "button";
      button.textContent = addLabel;
      button.dataset.productHandle = handle;
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        handleCartClick(button, card, handle);
      });

      getActionContainer(card).append(button);
    });
  }

  let scanQueued = false;
  const queueScan = () => {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(() => {
      scanQueued = false;
      injectButtons();
    });
  };

  const observer = new MutationObserver(queueScan);
  observer.observe(document.body, { childList: true, subtree: true });
  injectButtons();
})();
